import { makeAutoObservable, runInAction } from "mobx";
import apiClient, { api } from "../utils/apiClient";

class ProjectStore {
  selectedProject = null;
  allowedServices = [];
  assignedProjects = [];
  assignedProjectsLoaded = false;
  assignedProjectsLoading = false;
  allServices = [];
  allServicesLoaded = false;
  allServicesLoading = false;
  selectedProjectTags = [];

  projectTags = [];
  selectRequestId = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedProject(project) {
    if (!project || project === null) {
      console.warn("setSelectedProject called with null or undefined project");
      return;
    }
    // Only the latest selection may apply its tags/selection (fast switches race).
    const seq = ++this.selectRequestId;
    apiClient
      .get(`/api/tags/projects/${project}`)
      .then(({ data }) => {
        runInAction(() => {
          if (seq === this.selectRequestId) this.selectedProjectTags = data.tags;
        });
      })
      .finally(() => {
        runInAction(() => {
          if (seq === this.selectRequestId) this.selectedProject = project;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setAllowedServices(services) {
    this.allowedServices = services;
  }

  get selectedProjectTagsCsv() {
    return (this.selectedProjectTags || [])
      .map((tag) => String(tag.id))
      .join(",");
  }

  clearAssignedProjects() {
    this.assignedProjects = [];
    this.assignedProjectsLoaded = false;
    this.assignedProjectsLoading = false;
    this.selectedProject = null;
    this.allowedServices = [];
  }

  async loadAllServices() {
    // Own lock: sharing assignedProjectsLoading made loadAssignedProjects bail out.
    if (this.allServicesLoaded || this.allServicesLoading) return;
    this.allServicesLoading = true;
    try {
      const { data } = await api.get("/api/services");
      runInAction(() => {
        if (data.ok && Array.isArray(data.services)) {
          this.allServices = data.services.filter((s) => s.path);
        }
        this.allServicesLoaded = true;
      });
    } catch {
      runInAction(() => {
        this.allServices = [];
        this.allServicesLoaded = true;
      });
    } finally {
      runInAction(() => {
        this.allServicesLoading = false;
      });
    }
  }

  async loadAssignedProjects(user) {
    const userRole = user?.role || "user";
    const shouldLoadAssignedProjects = Boolean(
      user && !["admin", "sysAdmin", "official"].includes(userRole),
    );

    if (!shouldLoadAssignedProjects) {
      this.clearAssignedProjects();
      this.assignedProjectsLoaded = true;
      return;
    }

    if (this.assignedProjectsLoading) {
      return;
    }

    this.assignedProjectsLoading = true;

    try {
      const { data } = await api.get("/api/user/projects");
      this.assignedProjects = data.ok ? data.projects || [] : [];
      this.allowedServices = data.ok
        ? (data.projects || []).flatMap((p) => p.services || [])
        : [];
      this.assignedProjectsLoaded = true;
    } catch {
      this.assignedProjects = [];
      this.assignedProjectsLoaded = true;
    } finally {
      this.assignedProjectsLoading = false;
    }
  }
}

const projectStore = new ProjectStore();
export default projectStore;
